module.exports = __webpack_public_path__ + "static/polityka_prywatnosci_i_cookies_de-5ea2633eccbc0999a701e9fae83867fa.pdf";